"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.centsToCurrency = void 0;
const numeral_1 = __importDefault(require("numeral"));
const centsToCurrency = (cents, format = '$0,0.00', floor = false) => {
    const value = cents / 100;
    return (0, numeral_1.default)(floor ? Math.floor(value) : value).format(format);
};
exports.centsToCurrency = centsToCurrency;
